<script setup>
import Icon from 'dashboard/components-next/icon/Icon.vue';

defineProps({
  id: {
    type: String,
    default: '',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  hasError: {
    type: Boolean,
    default: false,
  },
});

defineEmits(['change']);

const modelValue = defineModel({
  type: [String, Number],
  default: '',
});
</script>

<template>
  <div class="relative w-full min-w-0">
    <select
      :id="id"
      v-model="modelValue"
      :disabled="disabled"
      class="reset-base block w-full min-h-10 cursor-pointer !appearance-none [-webkit-appearance:none] [-moz-appearance:none] [&::-ms-expand]:hidden rounded-xl border-0 bg-n-alpha-black2 py-2.5 pl-3.5 pr-10 text-sm leading-6 text-n-slate-12 shadow-sm outline outline-1 outline-offset-[-1px] transition-colors dark:bg-n-alpha-black2"
      :class="
        hasError
          ? 'outline-n-ruby-8 hover:outline-n-ruby-9 focus:outline-n-ruby-9'
          : 'outline-n-weak hover:outline-n-slate-6 focus:outline-n-brand dark:text-n-slate-12'
      "
      @change="$emit('change', $event)"
    >
      <slot />
    </select>
    <span
      class="pointer-events-none absolute inset-y-0 right-0 z-[1] flex w-10 items-center justify-center text-n-slate-10"
      aria-hidden="true"
    >
      <Icon icon="i-lucide-chevron-down" class="size-4 shrink-0" />
    </span>
  </div>
</template>
